import styled from '@emotion/styled';

import EmptyTableIcon from '../Icons/EmptyTableIcon';

interface EmptyStateProps {
  label: string;
  optionalComp?: React.ReactNode;
  icon?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  label,
  optionalComp,
  icon,
}) => {
  return (
    <Container>
      <EmptySection>
        {icon ?? <EmptyTableIcon />}

        <LabelArea>
          <Label>{label}</Label>
          <OptionalLabel>{optionalComp}</OptionalLabel>
        </LabelArea>
      </EmptySection>
    </Container>
  );
};

export default EmptyState;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 37px;
  padding: 72px;

  text-align: center;
`;

const EmptySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

const Label = styled.div`
  color: black;
  font-size: 16px;
  user-select: none;
`;

const OptionalLabel = styled.div`
  color: #5D665F;
  font-size: 14px;
  user-select: none;
`;

const LabelArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
`;
